import { useTranslation } from "react-i18next";
import { DataTable } from "../../../../../../../shared/components/data-table/DataTable";
import TableDeleteButton from "../../../../../../../shared/components/button/TableDeleteButton";
import UpdateClientCategoryDialog from "./UpdateClientCategoryDialog";
import TableHeaderSortingButton from "../../../../../../../shared/components/button/TableHeaderSortingButton";

const ClientsCategoryTable = ({
  data,
  onCategoryEdition,
  onCategoryDeletion,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "code",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.categories.table.code")}
          />
        );
      },
    },
    {
      accessorKey: "name",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.categories.table.name")}
          />
        );
      },
    },
    {
      accessorKey: "description",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.categories.table.description")}
          />
        );
      },
    },
    {
      accessorKey: "products",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.categories.table.products")}
          />
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <UpdateClientCategoryDialog
              category={data}
              onSubmitHandler={(formValues) =>
                onCategoryEdition(data.id, formValues)
              }
            />
            <TableDeleteButton
              onClickHandler={() => onCategoryDeletion(data.id)}
            />
          </div>
        );
      },
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default ClientsCategoryTable;
